import { render, staticRenderFns } from "./GoodsHistoryTable.vue?vue&type=template&id=e569a3c0&"
import script from "./GoodsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./GoodsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./GoodsHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports